import { render, staticRenderFns } from "./StartForm16.vue?vue&type=template&id=d40fbd7e&scoped=true"
import script from "./StartForm16.vue?vue&type=script&lang=ts"
export * from "./StartForm16.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40fbd7e",
  null
  
)

export default component.exports